module.exports = __webpack_public_path__ + "img/13.2c464b14.jpg";